import React from 'react';
import { Controller } from 'react-hook-form';
import { InputSwitch } from 'primereact/inputswitch';
import LabelName from 'components/UI/LabelName/LabelName';
import { useUserDetailsContext } from 'context/userDetailsContext';

function EventFirmWide({ control, watch }) {
  const { userDetails, access_level } = useUserDetailsContext();
  const firmWideWatcher = watch('firm_wide');

  // Only show for admin users
  if (access_level !== 'firm-admin' && !userDetails?.adminPrivileges) {
    return null;
  }

  return (
    <>
      <div className="d-flex align-items-center py-2 F-size14 flex-wrap">
        <div className="col-md-4 col-12">
          <LabelName required={false} htmlFor="firm_wide">
            Firm-Wide Event
          </LabelName>
        </div>
        <div className="col-md-8 col-12 d-flex align-items-center justify-content-start text-capitalize edit-field">
          <div className="w-100">
            <Controller
              name="firm_wide"
              control={control}
              defaultValue={false}
              render={({ field }) => (
                <InputSwitch name={field.name} checked={field.value} onChange={(e) => field.onChange(e.value)} className="input-swich" />
              )}
            />
          </div>
        </div>
      </div>
      {firmWideWatcher && (
        <div className="d-flex align-items-center mb-2">
          <div className="col-12">
            <div
              className="d-flex align-items-center p-2 rounded"
              style={{ backgroundColor: '#FFF3CD', border: '1px solid #FFECB5', color: '#856404' }}
            >
              <i className="pi pi-exclamation-triangle me-2" style={{ color: '#FF9800', fontSize: '16px' }}></i>
              <span className="F-size14">This will be a firm-wide event visible to all employees</span>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default EventFirmWide;
